import React from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="not-found">
      <div className="not-found-code">404</div>
      <p className="text-[16px] text-slate-500 m-0 mb-6">
        The page you're looking for doesn't exist
      </p>
      <Button
        type="primary"
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate("/home")}
        size="large"
      >
        Back to Home
      </Button>
    </div>
  );
}
